import AddCharacterModal from "modals/content/add-character/AddCharacterModal";
import ConfirmationModal from "modals/content/confirmation/ConfirmationModal";
import DeepDungeonsModal from "modals/content/deep-dungeons/DeepDungeonsModal";
import DungeonsModal from "modals/content/dungeons/DungeonsModal";
import EnemiesModal from "modals/content/enemies/EnemiesModal";
import ExtractionsModal from "modals/content/extractions/ExtractionsModal";
import FatesModal from "modals/content/fates/FatesModal";
import FieldOperationsModal from "modals/content/field-operations/FieldOperationsModal";
import FishingModal from "modals/content/fishing/FishingModal";
import GatheringModal from "modals/content/gathering/GatheringModal";
import LevesModal from "modals/content/leves/LevesModal";
import LocationsModal from "modals/content/locations/LocationsModal";
import MarketsModal from "modals/content/markets/MarketsModal";
import OtherModal from "modals/content/other/OtherModal";
import QuestsModal from "modals/content/quests/QuestsModal";
import RaidsModal from "modals/content/raids/RaidsModal";
import RecipesModal from "modals/content/recipes/RecipesModal";
import RoulettesModal from "modals/content/roulettes/RoulettesModal";
import ShopsModal from "modals/content/shops/ShopsModal";
import TrialsModal from "modals/content/trials/TrialsModal";
import VariantsModal from "modals/content/variants/VariantsModal";
import { ModalsProps } from "modals/types";
import { Component } from "react";
import { connect } from "react-redux";
import { AppState } from "types/app";
import "./Modals.css";

const mapStateToProps = (state:AppState):ModalsProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
	};
};

class Modals extends Component<ModalsProps.Component> {
	render():JSX.Element{
		return (
			<div id="modals-container">
				<ConfirmationModal />
				<DungeonsModal />
				<EnemiesModal />
				<ExtractionsModal />
				<FatesModal />
				<FishingModal />
				<GatheringModal />
				<LevesModal />
				<LocationsModal />
				<MarketsModal />
				<OtherModal />
				<QuestsModal />
				<RaidsModal />
				<RecipesModal />
				<ShopsModal />
				<TrialsModal />
				<AddCharacterModal />
				<DeepDungeonsModal />
				<FieldOperationsModal />
				<RoulettesModal />
				<VariantsModal />
			</div>
		);
	}
}
export default connect(mapStateToProps)(Modals);
